const ClinicDefinitionAPI = require('../../services/api/clinicdefinition');
const eventBus = require('../../utils/EventBus');
const clinicDefinitionService = new ClinicDefinitionAPI();
const { FETCH_TAGS, TOAST, ERROR, SUCCESS } = require('../../events');

module.exports = async ({ tag, id }) => {
  try {
    await clinicDefinitionService.globalTags({ tagId: id }).patch({
      payload: {
        tag,
      },
    });
    eventBus.fire(TOAST, {
      items: [
        {
          type: SUCCESS,
          message: 'Update saved',
        },
      ],
    });
  } catch (error) {
    eventBus.fire(TOAST, {
      items: [
        {
          type: ERROR,
          message: error.message,
        },
      ],
    });
  }
  eventBus.fire(FETCH_TAGS, {
    data: await clinicDefinitionService.globalTags().getAll(),
  });
};
